const BUTTON_GAP = 4;
const PADDING_X = 8;

/**
 * Computes the total pixel width of the action column based on the maximum
 * number of actions visible in any row.
 *
 * Layout: [paddingLeft] [btn] [gap] [btn] ... [paddingRight]
 *
 * Returns 0 when maxActionCount is 0 (action column should not render).
 */
export function getActionColumnWidth(maxActionCount: number, buttonSizePx: number): number {
  if (maxActionCount <= 0) {
    return 0;
  }

  return maxActionCount * buttonSizePx + (maxActionCount - 1) * BUTTON_GAP + 2 * PADDING_X;
}
